export default [
  {
    path: '/feedback/list',
    name: 'feedback-list',
    component: () => import('@/views/feedback/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Feedback List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Feedback' }, { title: 'Feedback List', active: true }],
      permissions: ['feedback_list']
    }
  }
]
